var $ = require('jquery');
var easy_drop_down = require('easydropdown');
// alert('a')

var initPage = function(evt, el) {
	// alert('b')
	// alert( $(el).find('select').size() )
	$('select').not('.is-customized').each(function(i, el){
		easy_drop_down( el, {
		// $(el).find('.intro__selects__new select').each(function(i, select){
			// easy_drop_down( select, {
				behavior: {
					maxVisibleItems:6,
					useNativeUiOnMobile: false,
					showPlaceholderWhenOpen: true,
				}
			// } );
		});
		$(el).addClass('is-customized');
		$(el).parent().addClass('is-customized');
		
	});

	$('.post__grid__filter__checkbox__bloc').not('.is-customized').each(function(i, el){
		const $bloc = $(el);
		const $title = $bloc.find('.post__grid__filter__checkbox__title');
		
		$title.click(function(){
			$('.post__grid__filter__checkbox__bloc.is-active').not($bloc).removeClass('is-active'); // ferme les autres
			$bloc.toggleClass('is-active');
		});

		// Ferme si on clique ailleurs
		$(document).on('click', function(e) {
			if (!$bloc.is(e.target) && $bloc.has(e.target).length === 0) {
				$bloc.removeClass('is-active');
			}
		});

		$bloc.addClass('is-customized');
	});
};

$(window).on('site:initPage', initPage);
$(window).on('sksmoothanim:nextPageFadeStart', initPage);
